import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/HomePage";
import About from "./pages/About";
import Layout from "./components/Layout";
import Service from "./pages/Services";
import Incorporation from "./pages/AllServices/Incorporation";
import Accounting from "./pages/AllServices/Accounting";
import Taxation from "./pages/AllServices/Taxation";
import Sole_Proprietorship from "./pages/AllServices/SoleProprietorship";
import Partnership_Firm from "./pages/AllServices/PartnershipFirm";
import Limited_Liability from "./pages/AllServices/LimitedLiability";
import One_Person_Company from "./pages/AllServices/OnePersonCompany";
import PrivateLimitedCompany from "./pages/AllServices/PrivateLimitedCompany";
import PublicLimitedCompany from "./pages/AllServices/PublicLimitedCompany";
import Direct_Tax_Services from "./pages/AllServices/DirectTaxServices";
import Income_tax from "./pages/AllServices/IncomeTax";
import Corporate_Tax from "./pages/AllServices/CorporateTax";
import International_Tax_Services from "./pages/AllServices/InternationalTaxServices";
import Transfer_Pricing from "./pages/AllServices/TransferPricing";
import DTAA_Advisory from "./pages/AllServices/DTAAAdvisory";
import NRI_Taxatios from "./pages/AllServices/NRITaxatios";
import Indirect_Tax_Service from "./pages/AllServices/IndirectTaxService";
import GST_Compliance from "./pages/AllServices/GSTCompliance";
import Blogs from "./pages/Blogs";
import Blog_Details from "./pages/BlogDetails";
import GST_Due_Diligence_Services from "./pages/AllServices/GSTDueDiligenceServices";
import GST_Opinion_Services from "./pages/AllServices/GSTOpinionServices";
import GST_Classification_Services from "./pages/AllServices/GSTClassificationServices";
import GST_Litigation_Services from "./pages/AllServices/GSTLitigationServices";
import GST_Search_Inquiry_Support_Services from "./pages/AllServices/GSTSearchInquirySupportServices";
import E_Way_Bill_Consultancy_Services from "./pages/AllServices/EWayBillConsultancyServices";
import GST_Refund_Services from "./pages/AllServices/GSTRefundServices";
import Specialized_Tax_Services from "./pages/AllServices/SpecializedTaxServices";
import GST_Return_Preparation_Services from "./pages/AllServices/GSTReturnPreparationServices";
import Audit_And_Assurance_Services from "./pages/AllServices/AuditAndAssuranceServices";
import Statutory_Audit_Services from "./pages/AllServices/StatutoryAuditServices";
import Internal_Audit_Services from "./pages/AllServices/InternalAuditServices";
import Tax_Audit_Services from "./pages/AllServices/TaxAuditServices";
import Forensic_Audit_Services from "./pages/AllServices/ForensicAuditServices";
import ConsultancyServices from "./pages/AllServices/ConsultancyServices";
import BusinessAdvisory from "./pages/AllServices/BusinessAdvisoryCorporateStrategy";
import GST_Audit_Services from "./pages/AllServices/GSTAuditServices";
import RiskComplianceConsultancy from "./pages/AllServices/RiskComplianceConsultancy";
import StartupSMEConsultancy from "./pages/AllServices/StartupSmeConsultancy";
import FinanceConsultancy from "./pages/AllServices/FinanceConsultancy";
import Concurrent_Audit_Services from "./pages/AllServices/ConcurrentAuditServices";
import CorporateFinance from "./pages/AllServices/CorporateFinanceTransactionAdvisory";
import ITdigital_Transformation from "./pages/AllServices/ITDigitalTransformationAdvisory";
import Compliance_Audit_Services from "./pages/AllServices/ComplianceAuditServices";
import Information_System_Audit_Services from "./pages/AllServices/InformationSystemAuditServices";
import Management_Audit_And_Risk_Assessment_Services from "./pages/AllServices/ManagementAuditAndRiskAssessmentServices";
import Departmental_And_Process_Audit_Services from "./pages/AllServices/DepartmentalAndProcessAuditServices";
import Wealth_Trust_Succession_planning from "./pages/AllServices/WealthTrustSuccessionPlanning";
import ContactUs from "./pages/ContactUs";
import ComingSoon from "./pages/ComingSoon";

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Service />} />
          <Route path="/incorporation" element={<Incorporation />} />
          <Route path="/accounting" element={<Accounting />} />
          <Route path="/taxation" element={<Taxation />} />
          <Route path="/sole-proprietorship" element={<Sole_Proprietorship />} />
          <Route path="/partnership-firm" element={<Partnership_Firm />} />
          <Route path="/limited-liability" element={<Limited_Liability />} />
          <Route path="/one-person-company" element={<One_Person_Company />} />
          <Route path="/private-limited-company" element={<PrivateLimitedCompany />} />
          <Route path="/public-limited-company" element={<PublicLimitedCompany />} />
          <Route path="/direct-tax-services" element={<Direct_Tax_Services />} />
          <Route path="/income-tax" element={<Income_tax />} />
          <Route path="/corporate-tax" element={<Corporate_Tax />} />
          <Route path="/international-tax-services" element={<International_Tax_Services />} />
          <Route path="/transfer-pricing" element={<Transfer_Pricing />} />
          <Route path="/dtaa-advisory" element={<DTAA_Advisory />} />
          <Route path="/nri-taxatios" element={<NRI_Taxatios />} />
          <Route path="/indirect-tax-service" element={<Indirect_Tax_Service />} />
          <Route path="/gst-compliance" element={<GST_Compliance />} />
          <Route path="/gst-due-diligence-services" element={<GST_Due_Diligence_Services />} />
          <Route path="/gst-opinion-services" element={<GST_Opinion_Services />} />
          <Route path="/gst-classification-services" element={<GST_Classification_Services />} />
          <Route path="/gst-litigation-services" element={<GST_Litigation_Services />} />
          <Route path="/e-way-bill-consultancy-services" element={<E_Way_Bill_Consultancy_Services />} />
          <Route path="/gst-refund-services" element={<GST_Refund_Services />} />
          <Route path="/specialized_tax-services" element={<Specialized_Tax_Services />} />
          <Route path="/gst-return-preparation-services" element={<GST_Return_Preparation_Services />} />
          <Route path="/audit-and-assurance-services" element={<Audit_And_Assurance_Services />} />
          <Route path="/statutory-audit-services" element={<Statutory_Audit_Services />} />
          <Route path="/internal-audit-services" element={<Internal_Audit_Services />} />
          <Route path="/tax-audit-services" element={<Tax_Audit_Services />} />
          <Route path="/forensic-audit-services" element={<Forensic_Audit_Services />} />
          <Route path="/consultancy-services" element={<ConsultancyServices />} />
          <Route path="/business-advisory&corporate-strategy" element={<BusinessAdvisory />} />
          <Route path="/gst-audit-services" element={<GST_Audit_Services />} />
          <Route path="/RiskComplianceConsultancy" element={<RiskComplianceConsultancy />} />
          <Route path="/startup&sme-consultancy" element={<StartupSMEConsultancy />} />
          <Route path="/finance-consultancy" element={<FinanceConsultancy />} />
          <Route path="/concurrent-audit-services" element={<Concurrent_Audit_Services />} />
          <Route path="/corporate-finance&transaction-advisory" element={<CorporateFinance />} />
          <Route path="/it&digital-transformation-advisory" element={<ITdigital_Transformation />} />
          <Route path="/compliance-audit-services" element={<Compliance_Audit_Services />} />
          <Route path="/information-system-audit-services" element={<Information_System_Audit_Services />} />
          <Route path="/management-audit&risk-assessment-services" element={<Management_Audit_And_Risk_Assessment_Services />} />
          <Route path="/departmental&process-audit-services" element={<Departmental_And_Process_Audit_Services />} />
          <Route path="/wealth-trust&succession-planning" element={<Wealth_Trust_Succession_planning />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/coming-soon" element={<ComingSoon />} />

          <Route path="/gst-search-inquiry-support-services" element={<GST_Search_Inquiry_Support_Services />} />
          <Route path="/Blogs" element={<Blogs />} />
          <Route path="/blog/:blogSlug" element={<Blog_Details />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;